export const BENEFIT_ID_URL_SECTION = ':id';

export const STEP_URL_SECTION = ':step';

export const STEP_ROUTE_PATH = `/benefits/${BENEFIT_ID_URL_SECTION}/step/${STEP_URL_SECTION}`;

export const NEW_BENEFIT_ROUTE_PATH = `/benefits/new`;
